const state = {
  alertMessage: null,
  typeMessage: null,
  id: null,
  typeUpload: null,
  date: null,
};

const getters = {
  GetAlertMessage: (state) => {
    return {
      message: state.alertMessage,
      type: state.typeMessage,
      id: state.id,
      typeUpload: state.typeUpload,
      date: state.date,
    };
  },
};

export { state, getters };
